import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgDropdownPanelComponent } from './ng-dropdown-panel.component';
import { NgOptionComponent } from './ng-option.component';
import {
  NgFooterTemplateDirective,
  NgHeaderTemplateDirective,
  NgLabelTemplateDirective,
  NgLoadingSpinnerTemplateDirective,
  NgLoadingTextTemplateDirective,
  NgMultiLabelTemplateDirective,
  NgNotFoundTemplateDirective,
  NgOptgroupTemplateDirective,
  NgOptionTemplateDirective,
  NgTagTemplateDirective,
  NgItemLabelDirective,
  NgTypeToSearchTemplateDirective
} from './sp-templates.directive';

import { DefaultSelectionModelFactory } from './selection-model';


import { SpSelectComponent, SELECTION_MODEL_FACTORY } from './sp-select.component';


@NgModule({
  declarations: [
    SpSelectComponent,
    NgDropdownPanelComponent,
    NgOptionComponent,
    NgOptgroupTemplateDirective,
    NgOptionTemplateDirective,
    NgLabelTemplateDirective,
    NgMultiLabelTemplateDirective,
    NgHeaderTemplateDirective,
    NgFooterTemplateDirective,
    NgNotFoundTemplateDirective,
    NgTypeToSearchTemplateDirective,
    NgLoadingTextTemplateDirective,
    NgTagTemplateDirective,
    NgLoadingSpinnerTemplateDirective,
    NgItemLabelDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SpSelectComponent,
    NgOptionComponent,
    NgOptgroupTemplateDirective,
    NgOptionTemplateDirective,
    NgLabelTemplateDirective,
    NgMultiLabelTemplateDirective,
    NgHeaderTemplateDirective,
    NgFooterTemplateDirective,
    NgNotFoundTemplateDirective,
    NgTypeToSearchTemplateDirective,
    NgLoadingTextTemplateDirective,
    NgTagTemplateDirective,
    NgLoadingSpinnerTemplateDirective
  ],
  providers: [
    { provide: SELECTION_MODEL_FACTORY, useValue: DefaultSelectionModelFactory }
  ]
})
export class SpSelectModule { }
